// (function () {
//   'use strict';

//   if (window.CartQuantitySync) return;

//   const CART_MUTATION_PATHS = new Set([
//     '/cart/add.js',
//     '/cart/change.js',
//     '/cart/update.js',
//     '/cart/clear.js'
//   ]);

//   const nativeFetch = window.fetch.bind(window);

//   let currentCart = null;
//   let refreshPromise = null;
//   let applyFrame = null;

//   function toInteger(value, fallback = 0) {
//     const parsed = parseInt(value, 10);
//     return Number.isFinite(parsed) ? parsed : fallback;
//   }

//   function getRequestPath(input) {
//     try {
//       const requestUrl = typeof input === 'string' ? input : input?.url;

//       return new URL(requestUrl, window.location.origin).pathname;
//     } catch (error) {
//       return '';
//     }
//   }

//   /**
//    * Creates a map like:
//    *
//    * variant ID => total quantity currently in cart
//    *
//    * This also supports a variant appearing in multiple cart lines.
//    */
//   function getVariantQuantities(cart) {
//     const quantities = new Map();

//     if (!cart || !Array.isArray(cart.items)) {
//       return quantities;
//     }

//     cart.items.forEach((item) => {
//       const variantId = String(item.variant_id || item.id || '');

//       if (!variantId) return;

//       const previousQuantity = quantities.get(variantId) || 0;
//       const itemQuantity = toInteger(item.quantity);

//       quantities.set(
//         variantId,
//         previousQuantity + itemQuantity
//       );
//     });

//     return quantities;
//   }

//   /**
//    * Finds the product form related to a product quantity input.
//    *
//    * Works for:
//    * - PDP
//    * - product cards
//    * - quick view
//    * - recommendation drawers
//    * - sticky product section
//    */
//   function getAssociatedForm(element) {
//     if (element.form) {
//       return element.form;
//     }

//     const scopes = [
//       element.closest('.product-quantity-with-buy'),
//       element.closest('[data-product-quantity-wrapper]'),
//       element.closest('[data-product-wrapper]'),
//       element.closest('.product-card'),
//       element.closest('.shopify-section')
//     ].filter(Boolean);

//     for (const scope of scopes) {
//       const variantInput = scope.querySelector(
//         [
//           'form[action*="/cart/add"] input[name="id"]',
//           'form[action*="/cart/add"] select[name="id"]',
//           'form input[name="id"]',
//           'form select[name="id"]'
//         ].join(', ')
//       );

//       if (variantInput?.form) {
//         return variantInput.form;
//       }
//     }

//     return null;
//   }

//   /**
//    * Gets the currently selected variant ID for an input.
//    */
//   function getVariantId(element) {
//     const form = getAssociatedForm(element);

//     const variantInput = form?.querySelector(
//       'input[name="id"], select[name="id"]'
//     );

//     if (variantInput?.value) {
//       return String(variantInput.value);
//     }

//     const explicitVariantId =
//       element.getAttribute('data-variant-id') ||
//       element
//         .closest('[data-variant-id]')
//         ?.getAttribute('data-variant-id');

//     return explicitVariantId
//       ? String(explicitVariantId)
//       : '';
//   }

//   /**
//    * Returns the original inventory quantity before subtracting
//    * the quantity already in the cart.
//    */
//   function getInventoryTotal(input) {
//     const explicitStock = input.getAttribute('data-availablestock');

//     if (explicitStock !== null && explicitStock !== '') {
//       return Math.max(0, toInteger(explicitStock));
//     }

//     const storedStock = input.getAttribute('data-cart-sync-stock');

//     if (storedStock !== null && storedStock !== '') {
//       return Math.max(0, toInteger(storedStock));
//     }

//     const available = input.getAttribute('data-available');
//     const cartQuantity = input.getAttribute('data-cart-qty');

//     if (available !== null && available !== '') {
//       const total = Math.max(
//         0,
//         toInteger(available) + toInteger(cartQuantity)
//       );

//       input.setAttribute(
//         'data-cart-sync-stock',
//         String(total)
//       );

//       return total;
//     }

//     return null;
//   }

//   /**
//    * Determines whether Shopify inventory should limit the customer.
//    *
//    * If inventory policy is "continue", overselling is permitted.
//    */
//   function isInventoryLimited(input) {
//     const inventoryManagement =
//       input.getAttribute('data-inventorymgmt');

//     const inventoryPolicy =
//       input.getAttribute('data-inventory-policy');

//     if (inventoryPolicy === 'continue') {
//       return false;
//     }

//     if (inventoryManagement !== null) {
//       return inventoryManagement.trim() !== '';
//     }

//     return getInventoryTotal(input) !== null;
//   }

//   /**
//    * Supports Shopify quantity rule maximums.
//    */
//   function getRuleRemaining(input, quantityInCart) {
//     const ruleMax = input.getAttribute('data-max');

//     if (ruleMax === null || ruleMax === '') {
//       return null;
//     }

//     return Math.max(
//       0,
//       toInteger(ruleMax) - quantityInCart
//     );
//   }

//   /**
//    * Finds Add to cart buttons associated with the quantity input.
//    */
//   function getAddButtons(input) {
//     const buttons = new Set();
//     const form = getAssociatedForm(input);

//     if (form) {
//       form
//         .querySelectorAll(
//           'button[type="submit"], [data-add-to-cart]'
//         )
//         .forEach((button) => {
//           buttons.add(button);
//         });

//       if (form.id) {
//         document
//           .querySelectorAll(
//             `[data-form="${CSS.escape(form.id)}"]`
//           )
//           .forEach((button) => {
//             buttons.add(button);
//           });
//       }
//     }

//     const cardScope =
//       input.closest('.product-quantity-with-buy');

//     cardScope
//       ?.querySelectorAll(
//         [
//           'form[action*="/cart/add"] button[type="submit"]',
//           '[data-add-to-cart]'
//         ].join(', ')
//       )
//       .forEach((button) => {
//         buttons.add(button);
//       });

//     const productScope =
//       input.closest('[data-product-wrapper]');

//     productScope
//       ?.querySelectorAll('[data-add-to-cart]')
//       .forEach((button) => {
//         buttons.add(button);
//       });

//     return Array.from(buttons);
//   }

//   /**
//    * Updates quantity plus button and hidden quantity input state.
//    */
//   function updateInputControlState(input, clampValue = false) {
//     const availableAttribute =
//       input.getAttribute('data-available');

//     const available =
//       availableAttribute === null ||
//       availableAttribute === ''
//         ? null
//         : Math.max(
//             0,
//             toInteger(availableAttribute)
//           );

//     const minimum = Math.max(
//       1,
//       toInteger(input.getAttribute('min'), 1)
//     );

//     let currentValue = Math.max(
//       minimum,
//       toInteger(input.value, minimum)
//     );

//     if (clampValue && available !== null) {
//     if (available <= 0) {
//         currentValue = 1;
//     } else {
//         currentValue = Math.min(
//         currentValue,
//         available
//         );
//     }

//     input.value = String(currentValue);
//     }

//     const quantityWrapper =
//       input.closest('[data-quantity-wrapper]');

//     const plusButton =
//       quantityWrapper?.querySelector(
//         '[data-quantity-increment]'
//       );

//     const plusShouldBeDisabled =
//       available !== null &&
//       (
//         available <= 0 ||
//         currentValue >= available
//       );

//     // if (plusButton) {
//     //   plusButton.disabled = plusShouldBeDisabled;

//     //   plusButton.classList.toggle(
//     //     'disabled-minus',
//     //     plusShouldBeDisabled
//     //   );

//     //   plusButton.setAttribute(
//     //     'aria-disabled',
//     //     plusShouldBeDisabled
//     //       ? 'true'
//     //       : 'false'
//     //   );
//     // }

//     if (plusButton) {
//       plusButton.classList.toggle(
//         'disabled-minus',
//         plusShouldBeDisabled
//       );

//       // Remove any native disabled state added previously.
//       plusButton.removeAttribute('disabled');
//       plusButton.removeAttribute('aria-disabled');
//     }

//     const cardWrapper =
//       input.closest('.product-quantity-with-buy');

//     const hiddenQuantityInput =
//       cardWrapper?.querySelector(
//         '.hidden-quantity-input'
//       );

//     if (hiddenQuantityInput) {
//       hiddenQuantityInput.value = input.value;
//     }
//   }

//   /**
//    * Disables the add-to-cart button when all inventory
//    * has already been placed in the cart.
//    */
//   function setCartLimitState(input, remaining) {
//     const isLimited = isInventoryLimited(input);

//     const noMoreCanBeAdded =
//       isLimited &&
//       remaining !== null &&
//       remaining <= 0;

//     getAddButtons(input).forEach((button) => {
//       const text = button.querySelector('span');

//       if (noMoreCanBeAdded) {
//         if (
//           !button.hasAttribute(
//             'data-cart-sync-disabled'
//           )
//         ) {
//           const currentText =
//             text?.textContent.trim() || '';

//           const wasAlreadyCartLimited =
//             /all items in cart/i.test(currentText);

//           button.setAttribute(
//             'data-cart-sync-disabled',
//             'true'
//           );

//           /*
//            * Preserve buttons that were already disabled,
//            * for example because a variant is sold out.
//            */
//           if (
//             button.disabled &&
//             !wasAlreadyCartLimited
//           ) {
//             button.setAttribute(
//               'data-cart-sync-preserve-disabled',
//               'true'
//             );
//           }

//           if (
//             text &&
//             !text.hasAttribute(
//               'data-cart-sync-original-text'
//             )
//           ) {
//             text.setAttribute(
//               'data-cart-sync-original-text',
//               wasAlreadyCartLimited
//                 ? 'Add to basket'
//                 : currentText
//             );
//           }
//         }

//         button.disabled = true;

//         button.setAttribute(
//           'aria-disabled',
//           'true'
//         );

//         if (text) {
//           text.textContent = 'All items in cart';
//         }

//         return;
//       }

//       if (
//         !button.hasAttribute(
//           'data-cart-sync-disabled'
//         )
//       ) {
//         return;
//       }

//       const preserveDisabled =
//         button.hasAttribute(
//           'data-cart-sync-preserve-disabled'
//         );

//       button.removeAttribute(
//         'data-cart-sync-disabled'
//       );

//       button.removeAttribute(
//         'data-cart-sync-preserve-disabled'
//       );

//       if (!preserveDisabled) {
//         button.disabled = false;
//         button.removeAttribute('aria-disabled');
//       }

//       if (
//         text?.hasAttribute(
//           'data-cart-sync-original-text'
//         )
//       ) {
//         text.textContent =
//           text.getAttribute(
//             'data-cart-sync-original-text'
//           );

//         text.removeAttribute(
//           'data-cart-sync-original-text'
//         );
//       }
//     });
//   }

//   /**
//    * Updates all cart-related attributes for one quantity input.
//    */
//   function updateQuantityInput(
//     input,
//     quantityInCart
//   ) {
//     input.setAttribute(
//       'data-cart-qty',
//       String(quantityInCart)
//     );

//     /*
//      * This second spelling is retained for compatibility
//      * with theme code that accesses dataset.cartqty.
//      */
//     input.setAttribute(
//       'data-cartqty',
//       String(quantityInCart)
//     );

//     const inventoryLimited =
//       isInventoryLimited(input);

//     const inventoryTotal =
//       getInventoryTotal(input);

//     const inventoryRemaining =
//       inventoryLimited &&
//       inventoryTotal !== null
//         ? Math.max(
//             0,
//             inventoryTotal - quantityInCart
//           )
//         : null;

//     const ruleRemaining =
//       getRuleRemaining(
//         input,
//         quantityInCart
//       );

//     let remaining = inventoryRemaining;

//     if (remaining === null) {
//       remaining = ruleRemaining;
//     }

//     if (
//       remaining !== null &&
//       ruleRemaining !== null
//     ) {
//       remaining = Math.min(
//         remaining,
//         ruleRemaining
//       );
//     }

//     if (remaining !== null) {
//       input.setAttribute(
//         'data-available',
//         String(remaining)
//       );

//       input.max = String(remaining);
//     } else if (!inventoryLimited) {
//       /*
//        * The variant is not inventory limited, such as
//        * inventory policy "continue".
//        */
//       input.setAttribute(
//         'data-available',
//         '999999'
//       );

//       input.removeAttribute('max');
//     }

//     updateInputControlState(input, true);
//     setCartLimitState(input, remaining);

//     input.dispatchEvent(
//       new CustomEvent(
//         'cart:quantity-attribute-updated',
//         {
//           bubbles: true,
//           detail: {
//             variantId: getVariantId(input),
//             quantityInCart,
//             available: remaining
//           }
//         }
//       )
//     );
//   }

//   /**
//    * Applies the cart response to every product card and PDP
//    * currently rendered on the page.
//    */
//   function applyCart(cart) {
//     if (
//       !cart ||
//       !Array.isArray(cart.items)
//     ) {
//       return;
//     }

//     currentCart = cart;

//     const quantities =
//       getVariantQuantities(cart);

//     /*
//      * Update the theme's existing quantity-based-price
//      * custom element.
//      */
//     document
//       .querySelectorAll('quantity-based-price')
//       .forEach((element) => {
//         const variantId =
//           getVariantId(element);

//         if (variantId) {
//           element.setAttribute(
//             'data-variant-id',
//             variantId
//           );
//         }

//         element.setAttribute(
//           'qty-in-cart',
//           String(
//             quantities.get(variantId) || 0
//           )
//         );
//       });

//     /*
//      * Do not update cart drawer quantity inputs directly.
//      * They represent line quantities and are already
//      * controlled by the cart drawer.
//      *
//      * Only update product card, PDP, quick-view and
//      * sticky-product quantity inputs.
//      */
//     document
//       .querySelectorAll(
//         [
//           '[data-quantity-input]',
//           ':not(.ajax-cart-update)',
//           ':not([name="updates[]"])'
//         ].join('')
//       )
//       .forEach((input) => {
//         const variantId =
//           getVariantId(input);

//         if (!variantId) return;

//         input.setAttribute(
//           'data-variant-id',
//           variantId
//         );

//         updateQuantityInput(
//           input,
//           quantities.get(variantId) || 0
//         );
//       });

//     document.dispatchEvent(
//       new CustomEvent(
//         'cart:quantity-synced',
//         {
//           detail: {
//             cart,
//             quantities
//           }
//         }
//       )
//     );
//   }

//   /**
//    * Reapplies the last cart response after dynamic content
//    * such as quick view or recommendations is inserted.
//    */
//   function scheduleApply() {
//     if (!currentCart || applyFrame) {
//       return;
//     }

//     applyFrame =
//       window.requestAnimationFrame(() => {
//         applyFrame = null;
//         applyCart(currentCart);
//       });
//   }

//   /**
//    * Fetches the latest complete Shopify cart.
//    */
//   function refresh() {
//     if (refreshPromise) {
//       return refreshPromise;
//     }

//     refreshPromise = nativeFetch('/cart.js', {
//       headers: {
//         Accept: 'application/json'
//       },
//       credentials: 'same-origin'
//     })
//       .then((response) => {
//         if (!response.ok) {
//           throw new Error(
//             'Unable to refresh cart quantities.'
//           );
//         }

//         return response.json();
//       })
//       .then((cart) => {
//         applyCart(cart);
//         return cart;
//       })
//       .catch((error) => {
//         console.error(
//           'Cart quantity sync error:',
//           error
//         );

//         return null;
//       })
//       .finally(() => {
//         refreshPromise = null;
//       });

//     return refreshPromise;
//   }

//   /**
//    * Watch Shopify cart Ajax API calls.
//    */
//   window.fetch = function (input, init) {
//     const path = getRequestPath(input);

//     const responsePromise =
//       nativeFetch(input, init);

//     if (!CART_MUTATION_PATHS.has(path)) {
//       return responsePromise;
//     }

//     responsePromise
//       .then((response) => {
//         if (!response.ok) {
//           return null;
//         }

//         return response
//           .clone()
//           .json()
//           .then((payload) => {
//             /*
//              * cart/update.js can return a complete cart.
//              */
//             if (
//               payload &&
//               Array.isArray(payload.items)
//             ) {
//               applyCart(payload);
//               return payload;
//             }

//             /*
//              * cart/add.js and cart/change.js may return only
//              * a line item, so fetch the complete cart.
//              */
//             return refresh();
//           })
//           .catch(() => refresh());
//       })
//       .catch(() => null);

//     return responsePromise;
//   };

//   /*
//    * Existing theme event support.
//    */
//   document.addEventListener(
//     'cart:updated',
//     refresh
//   );

//   /*
//    * Update after a section is loaded in the Shopify editor.
//    */
//   document.addEventListener(
//     'shopify:section:load',
//     refresh
//   );

//   /*
//    * Update attributes when a customer changes variant.
//    */
//   document.addEventListener(
//     'change',
//     (event) => {
//       if (
//         !event.target.matches(
//           'input[name="id"], select[name="id"]'
//         )
//       ) {
//         return;
//       }

//       scheduleApply();
//     }
//   );

//   /*
//    * Keep plus button state synchronized when the customer
//    * manually changes the product quantity.
//    */
//   document.addEventListener(
//     'input',
//     (event) => {
//       const input = event.target.closest(
//         [
//           '[data-quantity-input]',
//           ':not(.ajax-cart-update)',
//           ':not([name="updates[]"])'
//         ].join('')
//       );

//       if (!input) return;

//       updateInputControlState(
//         input,
//         true
//       );
//     }
//   );

//   /*
//    * Update plus button state after quantity plus or minus click.
//    */
//   document.addEventListener(
//     'click',
//     (event) => {
//       const quantityButton =
//         event.target.closest(
//           [
//             '[data-quantity-increment]',
//             '[data-quantity-decrement]'
//           ].join(', ')
//         );

//       if (
//         !quantityButton ||
//         quantityButton.closest(
//           '[data-cart-item]'
//         )
//       ) {
//         return;
//       }

//       const input = quantityButton
//         .closest('[data-quantity-wrapper]')
//         ?.querySelector(
//           '[data-quantity-input]'
//         );

//       if (!input) return;

//       window.setTimeout(() => {
//         updateInputControlState(
//           input,
//           true
//         );
//       }, 0);
//     }
//   );

//   /*
//    * Product drawers, cart recommendations and quick view can
//    * replace their HTML after the initial page load.
//    */
//   const observer = new MutationObserver(
//     (mutations) => {
//       const hasAddedNodes =
//         mutations.some(
//           (mutation) =>
//             mutation.addedNodes.length > 0
//         );

//       if (hasAddedNodes) {
//         scheduleApply();
//       }
//     }
//   );

//   function initialize() {
//     if (document.body) {
//       observer.observe(
//         document.body,
//         {
//           childList: true,
//           subtree: true
//         }
//       );
//     }

//     refresh();
//   }

//   if (
//     document.readyState === 'loading'
//   ) {
//     document.addEventListener(
//       'DOMContentLoaded',
//       initialize,
//       {
//         once: true
//       }
//     );
//   } else {
//     initialize();
//   }

//   /*
//    * Public methods for manually refreshing, if required.
//    *
//    * Example:
//    * window.CartQuantitySync.refresh();
//    */
//   window.CartQuantitySync = {
//     refresh,
//     applyCart,
//     getCurrentCart: () => currentCart
//   };
// })();





(function () {
  'use strict';

  if (window.CartQuantitySync) return;

  const CART_MUTATION_PATHS = new Set([
    '/cart/add.js',
    '/cart/change.js',
    '/cart/update.js',
    '/cart/clear.js'
  ]);

  const IGNORED_MUTATION_SELECTORS =
    '#stock-error-message, #stock-error-message-popup, [data-quantity-error]';

  const nativeFetch = window.fetch.bind(window);

  const PDP_LIMIT_MESSAGE =
    'Maximum available quantity already in your cart.';
  const CARD_LIMIT_MESSAGE = 'No More Available';

  let currentCart = null;
  let refreshPromise = null;
  let applyFrame = null;

  function toInteger(value, fallback = 0) {
    const parsed = parseInt(value, 10);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function getRequestPath(input) {
    try {
      const requestUrl = typeof input === 'string' ? input : input?.url;

      return new URL(requestUrl, window.location.origin).pathname;
    } catch (error) {
      return '';
    }
  }


  function getVariantQuantities(cart) {
    const quantities = new Map();

    if (!cart || !Array.isArray(cart.items)) {
      return quantities;
    }

    cart.items.forEach((item) => {
      const variantId = String(item.variant_id || item.id || '');

      if (!variantId) return;

      const previousQuantity = quantities.get(variantId) || 0;
      const itemQuantity = toInteger(item.quantity);

      quantities.set(
        variantId,
        previousQuantity + itemQuantity
      );
    });

    return quantities;
  }

  function getAssociatedForm(element) {
    if (element.form) {
      return element.form;
    }

    const scopes = [
      element.closest('.product-quantity-with-buy'),
      element.closest('[data-product-quantity-wrapper]'),
      element.closest('[data-product-wrapper]'),
      element.closest('.product-card'),
      element.closest('.shopify-section')
    ].filter(Boolean);

    for (const scope of scopes) {
      const variantInput = scope.querySelector(
        [
          'form[action*="/cart/add"] input[name="id"]',
          'form[action*="/cart/add"] select[name="id"]',
          'form input[name="id"]',
          'form select[name="id"]'
        ].join(', ')
      );

      if (variantInput?.form) {
        return variantInput.form;
      }
    }

    return null;
  }


  function getVariantId(element) {
    const form = getAssociatedForm(element);

    const variantInput = form?.querySelector(
      'input[name="id"], select[name="id"]'
    );

    if (variantInput?.value) {
      return String(variantInput.value);
    }

    const explicitVariantId =
      element.getAttribute('data-variant-id') ||
      element
        .closest('[data-variant-id]')
        ?.getAttribute('data-variant-id');

    return explicitVariantId
      ? String(explicitVariantId)
      : '';
  }


  function getInventoryTotal(input) {
    const explicitStock = input.getAttribute('data-availablestock');

    if (explicitStock !== null && explicitStock !== '') {
      return Math.max(0, toInteger(explicitStock));
    }

    const storedStock = input.getAttribute('data-cart-sync-stock');

    if (storedStock !== null && storedStock !== '') {
      return Math.max(0, toInteger(storedStock));
    }

    const available = input.getAttribute('data-available');
    const cartQuantity = input.getAttribute('data-cart-qty');

    if (available !== null && available !== '') {
      const total = Math.max(
        0,
        toInteger(available) + toInteger(cartQuantity)
      );

      input.setAttribute(
        'data-cart-sync-stock',
        String(total)
      );

      return total;
    }

    return null;
  }

  function isInventoryLimited(input) {
    const inventoryManagement =
      input.getAttribute('data-inventorymgmt');

    const inventoryPolicy =
      input.getAttribute('data-inventory-policy');

    if (inventoryPolicy === 'continue') {
      return false;
    }

    if (inventoryManagement !== null) {
      return inventoryManagement.trim() !== '';
    }

    return getInventoryTotal(input) !== null;
  }


  function getRuleRemaining(input, quantityInCart) {
    const ruleMax = input.getAttribute('data-max');

    if (ruleMax === null || ruleMax === '') {
      return null;
    }

    return Math.max(
      0,
      toInteger(ruleMax) - quantityInCart
    );
  }


  function getAddButtons(input) {
    const buttons = new Set();
    const form = getAssociatedForm(input);

    if (form) {
      form
        .querySelectorAll(
          'button[type="submit"], [data-add-to-cart]'
        )
        .forEach((button) => {
          buttons.add(button);
        });

      if (form.id) {
        document
          .querySelectorAll(
            `[data-form="${CSS.escape(form.id)}"]`
          )
          .forEach((button) => {
            buttons.add(button);
          });
      }
    }

    const cardScope =
      input.closest('.product-quantity-with-buy');

    cardScope
      ?.querySelectorAll(
        [
          'form[action*="/cart/add"] button[type="submit"]',
          '[data-add-to-cart]'
        ].join(', ')
      )
      .forEach((button) => {
        buttons.add(button);
      });

    const productScope =
      input.closest('[data-product-wrapper]');

    productScope
      ?.querySelectorAll('[data-add-to-cart]')
      .forEach((button) => {
        buttons.add(button);
      });

    return Array.from(buttons);
  }

  function getPdpErrorElement(input) {
    const pdpScope = input.closest(
      '.product-main-content-wrapper'
    );

    return pdpScope
      ? pdpScope.querySelector('#stock-error-message')
      : null;
  }


  // function getCardErrorElement(input) {
  //   const cardScope =
  //     input.closest('.product-card') ||
  //     input.closest('.product-quantity-with-buy') ||
  //     input.closest('[data-product-wrapper]');

  //   return cardScope
  //     ? cardScope.querySelector('[data-quantity-error]')
  //     : null;
  // }
   function getCardErrorElement(input) {
    const cardScope =
      input.closest('.product-card-item') ||           
      input.closest('.related-content-layout__product-card') ||
      input.closest('.product-card');

    return cardScope
      ? cardScope.querySelector('[data-quantity-error]')
      : null;
  }


  function showQuantityError(input, reason, available) {
    const pdpError = getPdpErrorElement(input);

    if (pdpError) {
      pdpError.textContent =
        reason === 'availability'
          ? `Only ${available} available.`
          : PDP_LIMIT_MESSAGE;

      pdpError.style.display = 'block';
    }

    const cardError = getCardErrorElement(input);

    if (cardError) {
      if (reason === 'limit') {
        cardError.textContent = CARD_LIMIT_MESSAGE;
        cardError.hidden = false;
      } else {
        cardError.hidden = true;
        cardError.textContent = '';
      }
    }
  }

 
  function hideQuantityError(input) {
    const pdpError = getPdpErrorElement(input);

    if (pdpError) {
      pdpError.style.display = 'none';
      pdpError.textContent = '';
    }

    const cardError = getCardErrorElement(input);

    if (cardError) {
      cardError.hidden = true;
      cardError.textContent = '';
    }
  }


  function updateInputControlState(input, clampValue = false) {
    const availableAttribute =
      input.getAttribute('data-available');

    const available =
      availableAttribute === null ||
      availableAttribute === ''
        ? null
        : Math.max(
            0,
            toInteger(availableAttribute)
          );

    const minimum = Math.max(
      1,
      toInteger(input.getAttribute('min'), 1)
    );

    let currentValue = Math.max(
      minimum,
      toInteger(input.value, minimum)
    );

    if (clampValue && available !== null) {
      if (available <= 0) {
        currentValue = 1;
      } else {
        currentValue = Math.min(
          currentValue,
          available
        );
      }

      input.value = String(currentValue);
    }

    const quantityWrapper =
      input.closest('[data-quantity-wrapper]');

    const plusButton =
      quantityWrapper?.querySelector(
        '[data-quantity-increment]'
      );

    const plusShouldBeDisabled =
      available !== null &&
      (
        available <= 0 ||
        currentValue >= available
      );

    if (plusButton) {
      plusButton.classList.toggle(
        'disabled-minus',
        plusShouldBeDisabled
      );

      // Remove any native disabled state added previously.
      plusButton.removeAttribute('disabled');
      plusButton.removeAttribute('aria-disabled');
    }

    const cardWrapper =
      input.closest('.product-quantity-with-buy');

    const hiddenQuantityInput =
      cardWrapper?.querySelector(
        '.hidden-quantity-input'
      );

    if (hiddenQuantityInput) {
      hiddenQuantityInput.value = input.value;
    }
  }


  function setCartLimitState(input, remaining) {
    const isLimited = isInventoryLimited(input);

    const noMoreCanBeAdded =
      isLimited &&
      remaining !== null &&
      remaining <= 0;

    getAddButtons(input).forEach((button) => {
      if (noMoreCanBeAdded) {
        button.setAttribute(
          'data-cart-sync-disabled',
          'true'
        );

        button.disabled = true;

        button.setAttribute(
          'aria-disabled',
          'true'
        );

        return;
      }


      if (
        !button.hasAttribute(
          'data-cart-sync-disabled'
        )
      ) {
        return;
      }

      button.removeAttribute(
        'data-cart-sync-disabled'
      );

      button.disabled = false;
      button.removeAttribute('aria-disabled');
    });

    if (noMoreCanBeAdded) {
      showQuantityError(input, 'limit');
    } else {
      hideQuantityError(input);
    }
  }


  function updateQuantityInput(
    input,
    quantityInCart
  ) {
    input.setAttribute(
      'data-cart-qty',
      String(quantityInCart)
    );


    input.setAttribute(
      'data-cartqty',
      String(quantityInCart)
    );

    const inventoryLimited =
      isInventoryLimited(input);

    const inventoryTotal =
      getInventoryTotal(input);

    const inventoryRemaining =
      inventoryLimited &&
      inventoryTotal !== null
        ? Math.max(
            0,
            inventoryTotal - quantityInCart
          )
        : null;

    const ruleRemaining =
      getRuleRemaining(
        input,
        quantityInCart
      );

    let remaining = inventoryRemaining;

    if (remaining === null) {
      remaining = ruleRemaining;
    }

    if (
      remaining !== null &&
      ruleRemaining !== null
    ) {
      remaining = Math.min(
        remaining,
        ruleRemaining
      );
    }

    if (remaining !== null) {
      input.setAttribute(
        'data-available',
        String(remaining)
      );

      input.max = String(remaining);
    } else if (!inventoryLimited) {

      input.setAttribute(
        'data-available',
        '999999'
      );

      input.removeAttribute('max');
    }

    updateInputControlState(input, true);
    setCartLimitState(input, remaining);

    input.dispatchEvent(
      new CustomEvent(
        'cart:quantity-attribute-updated',
        {
          bubbles: true,
          detail: {
            variantId: getVariantId(input),
            quantityInCart,
            available: remaining
          }
        }
      )
    );
  }


  function applyCart(cart) {
    if (
      !cart ||
      !Array.isArray(cart.items)
    ) {
      return;
    }

    currentCart = cart;

    const quantities =
      getVariantQuantities(cart);


    document
      .querySelectorAll('quantity-based-price')
      .forEach((element) => {
        const variantId =
          getVariantId(element);

        if (variantId) {
          element.setAttribute(
            'data-variant-id',
            variantId
          );
        }

        element.setAttribute(
          'qty-in-cart',
          String(
            quantities.get(variantId) || 0
          )
        );
      });


    document
      .querySelectorAll(
        [
          '[data-quantity-input]',
          ':not(.ajax-cart-update)',
          ':not([name="updates[]"])'
        ].join('')
      )
      .forEach((input) => {
        const variantId =
          getVariantId(input);

        if (!variantId) return;

        input.setAttribute(
          'data-variant-id',
          variantId
        );

        updateQuantityInput(
          input,
          quantities.get(variantId) || 0
        );
      });

    document.dispatchEvent(
      new CustomEvent(
        'cart:quantity-synced',
        {
          detail: {
            cart,
            quantities
          }
        }
      )
    );
  }


  function scheduleApply() {
    if (!currentCart || applyFrame) {
      return;
    }

    applyFrame =
      window.requestAnimationFrame(() => {
        applyFrame = null;
        applyCart(currentCart);
      });
  }


  function refresh() {
    if (refreshPromise) {
      return refreshPromise;
    }

    refreshPromise = nativeFetch('/cart.js', {
      headers: {
        Accept: 'application/json'
      },
      credentials: 'same-origin'
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(
            'Unable to refresh cart quantities.'
          );
        }

        return response.json();
      })
      .then((cart) => {
        applyCart(cart);
        return cart;
      })
      .catch((error) => {
        console.error(
          'Cart quantity sync error:',
          error
        );

        return null;
      })
      .finally(() => {
        refreshPromise = null;
      });

    return refreshPromise;
  }


  window.fetch = function (input, init) {
    const path = getRequestPath(input);

    const responsePromise =
      nativeFetch(input, init);

    if (!CART_MUTATION_PATHS.has(path)) {
      return responsePromise;
    }

    responsePromise
      .then((response) => {
        if (!response.ok) {
          return null;
        }

        return response
          .clone()
          .json()
          .then((payload) => {
        
            if (
              payload &&
              Array.isArray(payload.items)
            ) {
              applyCart(payload);
              return payload;
            }


            return refresh();
          })
          .catch(() => refresh());
      })
      .catch(() => null);

    return responsePromise;
  };


  document.addEventListener(
    'cart:updated',
    refresh
  );


  document.addEventListener(
    'shopify:section:load',
    refresh
  );


  document.addEventListener(
    'change',
    (event) => {
      if (
        !event.target.matches(
          'input[name="id"], select[name="id"]'
        )
      ) {
        return;
      }

      scheduleApply();
    }
  );


  document.addEventListener(
    'input',
    (event) => {
      const input = event.target.closest(
        [
          '[data-quantity-input]',
          ':not(.ajax-cart-update)',
          ':not([name="updates[]"])'
        ].join('')
      );

      if (!input) return;

      updateInputControlState(
        input,
        true
      );
    }
  );


  document.addEventListener(
    'click',
    (event) => {
      const quantityButton =
        event.target.closest(
          [
            '[data-quantity-increment]',
            '[data-quantity-decrement]'
          ].join(', ')
        );

      if (
        !quantityButton ||
        quantityButton.closest(
          '[data-cart-item]'
        )
      ) {
        return;
      }

      const input = quantityButton
        .closest('[data-quantity-wrapper]')
        ?.querySelector(
          '[data-quantity-input]'
        );

      if (!input) return;

      window.setTimeout(() => {
        updateInputControlState(
          input,
          true
        );
      }, 0);
    }
  );


  function isIgnorableMutation(mutation) {
    const target =
      mutation.target.nodeType === Node.TEXT_NODE
        ? mutation.target.parentElement
        : mutation.target;

    return Boolean(
      target?.closest(IGNORED_MUTATION_SELECTORS)
    );
  }

  const observer = new MutationObserver(
    (mutations) => {
      const hasAddedNodes =
        mutations.some(
          (mutation) =>
            mutation.addedNodes.length > 0 &&
            !isIgnorableMutation(mutation)
        );

      if (hasAddedNodes) {
        scheduleApply();
      }
    }
  );

  function initialize() {
    if (document.body) {
      observer.observe(
        document.body,
        {
          childList: true,
          subtree: true
        }
      );
    }

    refresh();
  }

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initialize,
      {
        once: true
      }
    );
  } else {
    initialize();
  }


  window.CartQuantitySync = {
    refresh,
    applyCart,
    getCurrentCart: () => currentCart
  };
})();
